import type { ApplicationContext } from '@hc-frontend/core-context';
import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { SubmitPersonalInformationPlateTrackingOptions } from '../../entities/submit-personal-information-plate-tracking';
import type {
  SubmitPersonalInformationPlateTrackingRepository,
  SubmitPersonalInformationPlateTrackingResult,
} from '../../repositories/submit-personal-information-plate-tracking-repository';

export type TrackSubmitPersonalInformationPlateParams = Pick<
  ApplicationContext,
  'log'
> &
  Pick<
    SubmitPersonalInformationPlateTrackingRepository,
    'trackSubmitPersonalInformationPlate'
  >;

export type TrackSubmitPersonalInformationPlateUseCase = (
  options: SubmitPersonalInformationPlateTrackingOptions,
) => Promise<SubmitPersonalInformationPlateTrackingResult>;

export function trackSubmitPersonalInformationPlateFactory({
  trackSubmitPersonalInformationPlate,
  log,
}: TrackSubmitPersonalInformationPlateParams): TrackSubmitPersonalInformationPlateUseCase {
  return async (options) => {
    const parsedOptions =
      SubmitPersonalInformationPlateTrackingOptions.safeParse(options);
    if (!parsedOptions.success) {
      log({
        type: 'error',
        context: 'client',
        message: 'failedToTrackSubmitPersonalInformationPlate',
        data: {
          rootCause: parsedOptions.error,
        },
      });

      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTrackSubmitPersonalInformationPlate',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }

    const result = await trackSubmitPersonalInformationPlate(options);
    if (!result.success) {
      log({
        type: 'error',
        context: 'client',
        message: result.errors[0].code,
        data: {
          rootCause: result.errors[0].rootCause,
        },
      });
    }

    return result;
  };
}
